import H5Image from 'web-materials/dist/esm/components/common/H5Image';

export default function Img(props) {
  return (
    <H5Image
      {...props}
      type="origin"
      src={`${props?.src}`}
    />
  );
}
